
import { StandardEvents } from "@shopify/events";
(function(){
  function setupDock(sticky){
    const main=document.getElementById('MainContent');
    if(!main||!sticky||sticky.dataset.kamaDockReady)return;
    sticky.dataset.kamaDockReady='true';
    const header=document.querySelector('header-component');
    let queued=false;
    let pending=false;
    let failed=false;
    let requestNumber=0;
    const section=sticky.closest('.shopify-section');
    function getPicker(){return section&&section.querySelector('variant-picker[ref="mainVariantPicker"]');}
    function syncOptions(bar){
      const picker=getPicker();
      if(!picker)return;
      const groups=Array.from(picker.querySelectorAll('fieldset')).map(function(fieldset){
        const inputs=Array.from(fieldset.querySelectorAll('input[type="radio"][data-option-value-id]'));
        return {name:inputs[0]?.dataset.optionName||'Option',values:inputs.map(function(input){return {id:input.dataset.optionValueId,label:input.value,selected:input.checked,disabled:input.disabled};})};
      }).filter(function(group){return group.values.length>0;});
      picker.querySelectorAll('select').forEach(function(select){
        groups.push({name:select.getAttribute('aria-label')||select.closest('.variant-option')?.querySelector('label')?.textContent.trim()||'Option',values:Array.from(select.options).map(function(option){return {id:option.dataset.optionValueId,label:option.textContent.trim(),selected:option.selected,disabled:option.disabled};})});
      });
      if(!groups.length)return;
      let options=bar.querySelector('.v2-dock-options');
      if(!options){options=document.createElement('div');options.className='v2-dock-options';bar.insertBefore(options,bar.querySelector('.v2-dock-nav'));}
      const signature=JSON.stringify(groups);
      if(options.dataset.signature!==signature&&!pending){
        const fragment=document.createDocumentFragment();
        groups.forEach(function(group){
          const label=document.createElement('label');
          const name=document.createElement('span');name.textContent=group.name;
          const select=document.createElement('select');select.setAttribute('aria-label',group.name+' in quick add bar');
          group.values.forEach(function(value){const option=document.createElement('option');option.value=value.id;option.textContent=value.label;option.selected=value.selected;option.disabled=value.disabled;select.appendChild(option);});
          label.append(name,select);fragment.appendChild(label);
        });
        options.replaceChildren(fragment);options.dataset.signature=signature;
      }
      const button=bar.querySelector('.sticky-add-to-cart__button');
      if((pending||failed)&&button)button.disabled=true;
      options.querySelectorAll('select').forEach(function(select){select.disabled=pending;});
      if(pending)options.setAttribute('aria-busy','true');else options.removeAttribute('aria-busy');
      let error=bar.querySelector('.v2-dock-error');
      if(failed&&!error){error=document.createElement('p');error.className='v2-dock-error';error.setAttribute('role','alert');error.textContent='Could not update your selection. Please try again.';bar.insertBefore(error,bar.querySelector('.v2-dock-nav'));}
      if(!failed&&error)error.remove();
    }
    sticky.addEventListener('change',function(event){
      const select=event.target;
      if(!(select instanceof HTMLSelectElement)||!select.closest('.v2-dock-options'))return;
      const picker=getPicker();
      const target=picker&&Array.from(picker.querySelectorAll('[data-option-value-id]')).find(function(option){return option.dataset.optionValueId===select.value;});
      if(target instanceof HTMLInputElement){target.click();}
      else if(target instanceof HTMLOptionElement){const nativeSelect=target.closest('select');nativeSelect.value=target.value;nativeSelect.dispatchEvent(new Event('change',{bubbles:true}));}
    });
    sticky.addEventListener('click',function(event){if((pending||failed)&&event.target.closest('.sticky-add-to-cart__button')){event.preventDefault();event.stopImmediatePropagation();}},true);
    section?.addEventListener(StandardEvents.productSelect,function(event){
      if(event.target!==getPicker())return;
      const request=++requestNumber;
      pending=true;failed=false;schedule();
      event.promise.then(function(){if(request!==requestNumber)return;pending=false;failed=false;schedule();},function(){if(request!==requestNumber)return;pending=false;failed=true;schedule();});
    });
    function update(){
      queued=false;
      if(!sticky.isConnected)return;
      const bar=sticky.querySelector('.sticky-add-to-cart__bar');
      if(!bar)return;
      const source=main.querySelector('.v2n-nav, [data-product-jump-links]');
      const links=source?Array.from(source.querySelectorAll('a[href^="#"]')).filter(function(link){const target=document.getElementById(link.hash.slice(1));return target&&target.getClientRects().length>0;}):[];
      let nav=bar.querySelector('.v2-dock-nav');
      if(links.length){
        if(!nav){nav=document.createElement('nav');nav.className='v2-dock-nav';nav.setAttribute('aria-label','Jump to product information');bar.appendChild(nav);}
        const signature=links.map(function(link){return link.getAttribute('href')+'|'+link.textContent;}).join(';');
        if(nav.dataset.signature!==signature){nav.replaceChildren(...links.map(function(link){return link.cloneNode(true);}));nav.dataset.signature=signature;}
      }else if(nav){nav.remove();}
      syncOptions(bar);
      const top=Math.max(0,header?header.getBoundingClientRect().bottom:0)+8;
      main.style.setProperty('--v2-dock-top',top+'px');
      main.style.setProperty('--v2-dock-clearance',(Math.max(top,(header?header.offsetHeight:0)+8)+(window.innerWidth<750?bar.offsetHeight:0)+20)+'px');
      bar.inert=bar.dataset.stuck!=='true';
    }
    function schedule(){if(!queued){queued=true;requestAnimationFrame(update);}}
    const mutations=new MutationObserver(schedule);
    mutations.observe(sticky,{childList:true,subtree:true,attributes:true,attributeFilter:['data-stuck']});
    const sizes=new ResizeObserver(schedule);
    sizes.observe(sticky.querySelector('.sticky-add-to-cart__bar'));
    if(header)sizes.observe(header);
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    document.addEventListener('shopify:section:load',schedule);
    update();
  }
  function setupAll(){document.querySelectorAll('#MainContent sticky-add-to-cart').forEach(setupDock);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',setupAll,{once:true});}else{setupAll();}
  document.addEventListener('shopify:section:load',setupAll);
})();
